import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import AuthLayout from '@/layouts/AuthLayout';
import AdminLayout from '@/layouts/AdminLayout';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import LoginPage from '@/pages/LoginPage';
import AuthCallbackPage from '@/pages/AuthCallbackPage';
import HomePage from '@/pages/HomePage';
import DestacadosPage from '@/pages/DestacadosPage';
import CollectionsPage from '@/pages/CollectionsPage';
import BlogPage from '@/pages/BlogPage';
import BlogEditorPage from '@/pages/BlogEditorPage';
import ChipsPage from '@/pages/ChipsPage';
import UsuariosPage from '@/pages/UsuariosPage';
import ArtistasDestacadosPage from '@/pages/ArtistasDestacadosPage';
import CiudadesDestacadasPage from '@/pages/CiudadesDestacadasPage';
import ConfiguracionPage from '@/pages/ConfiguracionPage';
import DocumentacionPage from '@/pages/DocumentacionPage';

export default function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />

        {/* Auth (público) */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
        </Route>

        {/* Admin (protegido por Stytch) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomePage />} />
          <Route path="destacados" element={<DestacadosPage />} />
          <Route path="colecciones" element={<CollectionsPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:id" element={<BlogEditorPage />} />
          <Route path="chips" element={<ChipsPage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route
            path="artistas-destacados"
            element={<ArtistasDestacadosPage />}
          />
          <Route
            path="ciudades-destacadas"
            element={<CiudadesDestacadasPage />}
          />
          <Route path="configuracion" element={<ConfiguracionPage />} />
          <Route path="documentacion" element={<DocumentacionPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
